<template>
    <div :class="[`block block-featured-slides sethmob`]" data-aos="custom-fade-in">
        <div v-show="bgContentArray" :id="swiperContainerId" class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide"
                     v-for="(item, index) in bgContentArray"
                     :key="`featured-${index}-${Math.random()}`"
                     :data-swiper-slide-index="index"
                >
                    <component
                        :is="'div'"
                        :class="['main-anchor nolink']"
                    >
                        <div class="bgimg-outer">
                            <div class="shade-top"></div>
                            <div v-if="item.gameLink?.panelVideo.length || item.gameLink?.panelVideoMobile.length" :class="[mode, 'bgimg']">
                                <template v-if="item.gameLink?.panelVideoMobile?.length">
                                    <video class="show-desktop" preload="metadata" :class="`video-${index}`" :poster="item.gameLink?.panelImage?.[0]?.url"  webkit-playsinline playsinline muted>
                                        <source :src="item.gameLink?.panelVideo[0].url" type="video/mp4">
                                    </video>
                                    <video  class="show-mobile" preload="metadata" :class="`video-${index}`" :poster="item.gameLink?.homeBgImageMobile?.[0]?.url" webkit-playsinline playsinline muted>
                                        <source :src="item.gameLink?.panelVideoMobile[0].url" type="video/mp4">
                                    </video>
                                </template>
                                <template v-else>
                                    <video preload="metadata" class="both" :class="`video-${index}`" muted :poster="item.gameLink?.panelImage?.[0]?.url" webkit-playsinline playsinline>
                                        <source :src="item.gameLink?.panelVideo[0].url" type="video/mp4">
                                    </video>
                                </template>
                            </div>
                            <template v-else>
                                <template v-if="item.gameLink?.homeBgImageMobile?.[0]?.bgStyle">
                                    <div :class="[mode, 'bgimg show-desktop']" :style="item.gameLink?.panelImage?.[0]?.bgStyle"></div>
                                    <div :class="[mode, 'bgimg show-mobile']" :style="item.gameLink?.homeBgImageMobile?.[0]?.bgStyle"></div>
                                </template>
                                <template v-else>
                                    <div :class="[mode, 'bgimg']" :style="item.gameLink?.panelImage?.[0]?.bgStyle"></div>
                                </template>
                            </template>
                            <div class="shade-bottom"></div>
                        </div>

                        <div v-if="mode === 'home'" class="panel">
                            <div class="capper">
                                <div class="capper-padded">
                                    <div class="copy">
                                        <div class="b1">
                                            <div class="squareimg-outer" v-if="item.gameLink?.panelSquareImage?.[0]?.bgStyle">
                                                <div class="squareimg bgimg" :style="item.gameLink?.panelSquareImage[0].bgStyle"></div>
                                            </div>
                                            <div class="titles">
                                                <h2 v-if="item.gameLink?.panelTitle" v-html="gh.nl2br(item.gameLink?.panelTitle)"></h2>
                                                <h3 v-if="item.gameLink?.panelBlurb" v-html="gh.nl2br(item.gameLink?.panelBlurb)"></h3>
                                            </div>
                                        </div>
                                        <div class="btns">
                                            <div v-if="item.gameLink?.platforms?.length>0" class="btn1">
                                                <button
                                                    :aria-label="getButtonLabel(item.gameLink?.buyNowButtonLabel)"
                                                    class="btn btn-platforms"
                                                >
                                                    <span class="txt flex">{{ getButtonLabel(item.gameLink?.buyNowButtonLabel) }}</span>
                                                </button>
                                            </div>
                                            <div v-if="item.gameLink?.trailerLink" class="btn2">
                                                <button
                                                    aria-label="Play Trailer"
                                                    class="btn  btn-youtube"
                                                >
                                                    <span class="txt show-desktop flex">WATCH THE TRAILER</span>
                                                    <span class="txt show-mobile flex">TRAILER</span>
                                                    <span class="icon">
                                                        <VideoPlay/>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </component>
                </div>
            </div>
            <div class="swiper-nav-elements">
                <div class="swiper-buttons">
                    <div class="swiper-button swiper-button-next"></div>
                    <div class="swiper-button swiper-button-prev"></div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation, Pagination, Keyboard, EffectFade } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import gh from '@/helpers/gh';
import { mapState } from "vuex";
import { isMobile } from 'mobile-device-detect'
import VideoPlay from "@/components/svgs/VideoPlay.vue";
// Import GSAP and SplitText plugin

import gsap from '@/plugins/gsap';
import SplitText from '@/plugins/gsap/SplitText';
gsap.registerPlugin(SplitText);

Swiper.use([Navigation, Pagination, Keyboard, EffectFade]);

export default {
    name: "FeaturedSlides",
    components: {
        VideoPlay
    },
    data() {
        return {
            gh: gh,
            document: document,
            slider: null,
            swiperContainerId: null,
            swiperContainerSel: null,
            timeoutId: null,
            isDragging: false,

            autoplayIsPaused: false,
            systemPaused: false,
        }
    },
    props: {
        bgContentArray: {
            type: Array,
            required: true,
            default: null,
        },
        mode: {
            type: String,
            required: false,
            default: '',
        }
    },
    computed: {
        ...mapState({
            popupOpen: state => state.popupOpen,
        }),
    },
    watch: {
        popupOpen(newVal) {
            if (newVal) {
                this.pauseAutoplay()
                setTimeout(this.pauseAutoplay, 50)
            } else {
                this.resumeAutoplay()
            }
            // also pause resume video
            if (newVal) {
                clearTimeout(this.timeoutId);
                const container = document.querySelector(this.swiperContainerSel);
                const currentSlide = container.querySelector('.swiper-slide.swiper-slide-active');
                const isMobile = window.innerWidth <= 850;
                let video = currentSlide.querySelector(`video.${isMobile ? 'show-mobile' : 'show-desktop'}`);
                if (!video) {
                    video = currentSlide.querySelector(`video.both`);
                }
                if (video) {
                    this.systemPaused = true
                    video.pause();

                }
            } else {
                const container = document.querySelector(this.swiperContainerSel);
                const currentSlide = container.querySelector('.swiper-slide.swiper-slide-active');
                const isMobile = window.innerWidth <= 850;
                let video = currentSlide.querySelector(`video.${isMobile ? 'show-mobile' : 'show-desktop'}`);
                if (!video) {
                    video = currentSlide.querySelector(`video.both`);
                }
                if (video) {
                    this.systemPaused = false
                    video.play();

                } else {
                    // this.timeoutId = setTimeout(() => {
                    //     this.slider.slideNext();
                    // }, 5000);
                }
            }
        }
    },
    mounted() {
        this.swiperContainerId = 'fs-' + Date.now();
        this.swiperContainerSel = '#' + this.swiperContainerId;
        this.$nextTick(() => {
            this.init();
            this.initAnimations();
            this.gh.setHeightMobile();
            //this.onSlideChange()
        });
    },
    beforeUnmount() {
        clearTimeout(this.timeoutId);
        if (this.slider) this.slider.destroy();
        if (!isMobile) {
            window.removeEventListener('resize', this.onSlideChange);
        }
    },
    methods: {
        pauseAutoplay() {
            this.autoplayIsPaused = true
            clearTimeout(this.timeoutId)
        },
        resumeAutoplay() {
            const container = document.querySelector(this.swiperContainerSel);
            const currentSlide = container.querySelector('.swiper-slide.swiper-slide-active');
            const isMobile = window.innerWidth <= 850;
            let video = currentSlide.querySelector(`video.${isMobile ? 'show-mobile' : 'show-desktop'}`);
            if (!video) {
                video = currentSlide.querySelector(`video.both`);
            }
            if (video) {
                if (video.paused && !this.systemPaused) {
                    this.slider.slideNext();
                }
            } else {
                this.timeoutId = setTimeout(() => {
                    this.slider.slideNext();
                }, 5000);
            }

            this.autoplayIsPaused = false;
        },
        init() {
            this.slider = new Swiper(this.swiperContainerSel, {
                init: false,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 750,
                grabCursor: false,
                loop: (this.bgContentArray.length > 1),
                allowSlidePrev: (this.bgContentArray.length > 1),
                allowSlideNext: (this.bgContentArray.length > 1),
                simulateTouch: (this.bgContentArray.length > 1),
                touchRatio: 1,
                touchAngle: 45,
                slidesPerView: 1,
                preventClicks: false,
                preventClicksPropagation: false,
                touchStartPreventDefault: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: this.swiperContainerSel + ' .swiper-button-next',
                    prevEl: this.swiperContainerSel + ' .swiper-button-prev'
                },
                pagination: {
                    el: this.swiperContainerSel + ' .swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
            });
            this.slider.on('slideChangeTransitionStart', () => {
                this.onSlideChange()
                this.bindButtonEvents()
            });
            this.slider.on('afterInit', () => {
                this.onSlideChange()
                this.bindButtonEvents()

                if (!isMobile) {
                    window.addEventListener('resize', this.onSlideChange);
                }
            });

            setTimeout(() => this.slider.init(), 100);
        },
        initAnimations() {
            const slides = document.querySelectorAll(this.swiperContainerSel + ' .swiper-slide');
            slides.forEach(slide => {
                const bgimg = slide.querySelector('.bgimg');
                if (bgimg) {
                    gsap.set(bgimg, { scale: 1.05, filter: "grayscale(50%)" });
                }
                const title = slide.querySelector('h2');
                const subTitle = slide.querySelector('h3');
                if (title) {
                    gsap.set(title, { opacity: 0 });
                }
                if (subTitle) {
                    gsap.set(subTitle, { opacity: 0 });
                }
                const squareimgOuter = slide.querySelector('.squareimg-outer');
                if (squareimgOuter) {
                    gsap.set(squareimgOuter, { opacity: 0 });
                }
                // Ensure buttons start hidden
                const buttons1 = slide.querySelectorAll('.btn1');
                if (buttons1) {
                    gsap.set(buttons1, { opacity: 0, y: 15 });
                }
                // Ensure buttons start hidden
                const buttons2 = slide.querySelectorAll('.btn2');
                if (buttons2) {
                    gsap.set(buttons2, { opacity: 0, y: 15 });
                }
            });
        },
        onSlideChange() {
            clearTimeout(this.timeoutId);

            const container = document.querySelector(this.swiperContainerSel);
            const currentSlide = container.querySelector('.swiper-slide.swiper-slide-active');

            const isMobile = window.innerWidth <= 850;

            // Pick the correct video based on device type
            let video = currentSlide.querySelector(`video.${isMobile ? 'show-mobile' : 'show-desktop'}`);
            if (!video) {
                video = currentSlide.querySelector(`video.both`);
            }

            if (video) {
                video.currentTime = 0;
                video.volume = 0;
                video.muted = true;

                // Pause both just in case
                const mobileVideo = currentSlide.querySelector('video.show-mobile');
                const desktopVideo = currentSlide.querySelector('video.show-desktop');
                const bothVideo = currentSlide.querySelector('video.both');
                if (mobileVideo && mobileVideo !== video) mobileVideo.pause();
                if (desktopVideo && desktopVideo !== video) desktopVideo.pause();
                if (bothVideo && bothVideo !== video) bothVideo.pause();

                video.play().catch(err => {
                    console.warn('Video play failed:', err);
                });

                video.onended = () => {
                    if (!this.autoplayIsPaused) {
                        this.slider.slideNext();
                    }
                };
            } else {
                this.timeoutId = setTimeout(() => {
                    this.slider.slideNext();
                }, 4000);
            }

            this.animateSlide(currentSlide);
        },
        animateSlide(slide) {
            const bgimg = slide.querySelector('.bgimg');
            const squareimgOuter = slide.querySelector('.squareimg-outer');
            const title = slide.querySelector('h2');
            const subTitle = slide.querySelector('h3');
            const buttons1 = slide.querySelectorAll('.btn1');
            const buttons2 = slide.querySelectorAll('.btn2');

            // Animate background image from grayscale(50%) to grayscale(0%)
            let del = 0;
            let delStagger = 0.1;
            if (bgimg) {
                gsap.set(bgimg, { scale: 1.05 });
                gsap.fromTo(
                    bgimg,
                    { filter: "grayscale(75%)", scale: 1.05 },
                    { filter: "grayscale(0%)", scale: 1, duration: 0.75, ease: "power2.out", delay: del }
                );
            }

            // Fade in the square image container
            if (squareimgOuter) {
                del += 0.4;
                gsap.fromTo(
                    squareimgOuter,
                    { opacity: 0 },
                    { opacity: 1, duration: 0.75, ease: "power2.out", delay: del }
                );
            }

            // Animate h2 text using SplitText with a revert check to prevent nesting
            let len = 0;
            if (title) {
                del += delStagger;
                // Revert any existing SplitText instance and clear the reference
                if (title._splitText) {
                    title._splitText.revert();
                    title._splitText = null;
                }
                // Create a fresh SplitText instance (splitting into words)
                title._splitText = new SplitText(title, { type: "words" });
                gsap.set(title, { opacity: 1 });
                len = title._splitText.words.length;
                gsap.fromTo(
                    title._splitText.words,
                    { opacity: 0, y: 15 },
                    { opacity: 1, y: 0, duration: 0.75, ease: "power2.out", delay: del, stagger: 0.1 }
                );
            }

            // Animate h3 text
            if (subTitle) {
                del += (len * delStagger);
                gsap.fromTo(
                    subTitle,
                    { opacity: 0, y: 15 },
                    { opacity: 1, y: 0, duration: 0.75, ease: "power2.out", delay: del }
                );
            }

            // Animate buttons (btn1)
            if (buttons1) {
                del += delStagger;
                gsap.fromTo(
                    buttons1,
                    { opacity: 0, y: 15 },
                    { opacity: 1, y: 0, duration: 0.75, ease: "power2.out", delay: del }
                );
            }

            // Animate buttons (btn2)
            if (buttons2) {
                del += delStagger;
                gsap.fromTo(
                    buttons2,
                    { opacity: 0, y: 15 },
                    { opacity: 1, y: 0, duration: 0.75, ease: "power2.out", delay: del }
                );
            }
        },
        openYoutube(youtubeId) {
            this.$store.commit('openPopup', { youtubeId: youtubeId });
        },
        openPlatforms(gameLink) {
            this.$store.commit('openPopup', { platforms: true, gameLink: gameLink });
        },
        bindButtonEvents() {
            const container = document.querySelector(this.swiperContainerSel);
            if (!container) return;

            const buttons = container.querySelectorAll('.swiper-slide .btn');
            buttons.forEach(btn => {
                btn.removeEventListener('mouseenter', this.pauseAutoplay);
                btn.removeEventListener('mouseleave', this.resumeAutoplay);
                btn.removeEventListener('click', this.onButtonClick);
                btn.addEventListener('mouseenter', this.pauseAutoplay);
                btn.addEventListener('mouseleave', this.resumeAutoplay);
                btn.addEventListener('click', this.onButtonClick);

            });
        },
        onButtonClick(event) {
            const button = event.currentTarget;
            const slide = button.closest('.swiper-slide');
            if (!slide) return;

            const indexAttr = slide.getAttribute('data-swiper-slide-index');
            const index = indexAttr ? parseInt(indexAttr) : null;
            if (index === null || isNaN(index)) return;

            const item = this.bgContentArray[index];
            if (!item || !item.gameLink) return;

            if (button.classList.contains('btn-platforms')) {
                this.openPlatforms(item.gameLink);
            } else if (button.classList.contains('btn-youtube')) {
                this.openYoutube(item.gameLink.trailerLink);
            }

            // Manually pause autoplay to prevent race conditions on loop boundaries
            this.pauseAutoplay();
        },
        getButtonLabel(lbl) {
            if (!lbl) {
                lbl = "Buy Now"
            }
            return lbl
        }


    },
};
</script>
